import { makeStyles } from '@mui/styles';

const styles = () => ({
    container: {
        display: 'flex',
        flexDirection: 'row !important',
        alignItems: 'flex-start',
        width: '100%',
        backgroundColor: '#fef9e7',
        borderLeft: '3px solid #f9b115',
        borderRadius: '4px',
        padding: '10px 12px',
        marginBottom: '16px',
        boxSizing: 'border-box',
    },

    icon: {
        width: '20px',
        height: '20px',
        flexShrink: 0,
        marginRight: '10px',
        marginTop: '2px',
    },

    textContent: {
        display: 'flex',
        flexDirection: 'column !important',
        flex: 1,
    },

    title: {
        fontSize: '12px',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.4px',
        color: '#333333',
        marginBottom: '4px',
    },

    message: {
        fontSize: '13px',
        fontWeight: 400,
        color: '#333333',
        lineHeight: '1.6',
        display: 'block',
    },

    must: {
        textDecoration: 'underline',
        fontWeight: 400,
    },

    webcal: {
        fontFamily: 'monospace',
        backgroundColor: '#f1f3f5',
        padding: '0px 3px',
        borderRadius: '3px',
        fontSize: '12px',
    },
});

export default styles;
export const useStyles = makeStyles(styles);
